import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as AppActions from '../actions/app-state.actions';
import { AppState, initialAppState } from '../state';

const reducer: ActionReducer<AppState, Action> = createReducer(
  initialAppState,
  on(AppActions.setMainNavigation, (state, { mainNavigation }) => ({
    ...state,
    mainNavigation: {
      ...state.mainNavigation,
      data: mainNavigation,
    },
  })),
  on(AppActions.loadMainNavigation, (state) => ({
    ...state,
    mainNavigation: {
      ...state.mainNavigation,
      status: 'loading',
    },
  })),
  on(AppActions.loadMainNavigationSuccess, (state, { mainNavData }) => ({
    ...state,
    mainNavigation: {
      data: mainNavData,
      error: null,
      status: 'success',
    },
  })),
  on(AppActions.loadMainNavigationFailure, (state, { error }) => ({
    ...state,
    mainNavigation: {
      ...state.mainNavigation,
      error: error,
      status: 'error',
    },
  })),
);

export function appStateReducer(state: AppState | undefined, action: Action): AppState {
  return reducer(state, action);
}
